import { DefaultService } from '@/services/DefaultService';

export default class FormaPagtoService extends DefaultService {
	constructor(http, router, env) {
		super(http, router, env);
	}

	findAllOld(column = 'datahorainc', order = 'desc', page = 0, limit = 50, ...params) {
		return this._http.get(encodeURI(`${this._env}/paiementoption/order/all.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

	findAll(column, order, page, limit, situacao, ...params) {
		return this._http.get(encodeURI(`${this._env}/vendas/forma-pagamento.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
            throw err;
		});
	}

    findAllCombo(params) {
		return this.findAllComboSituacao(1, params);
	}
    findAllComboSituacao(situacao = 1, ...params) {
		return this._http.get(encodeURI(`${this._env}/vendas/forma-pagamento/getcombo.json?situacao=${situacao}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
            throw err;
		});
	}

	updateSituacao(formapagamento) {
		return this._http.post(`${this._env}/vendas/forma-pagamento/updatesituacao`, formapagamento, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

	find(id) {
		return this._http.get(`${this._env}/vendas/forma-pagamento/${id}.json`, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
            throw err;
		});
	}

	save(form) {
		return this._http.post(`${this._env}/vendas/forma-pagamento`, form, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

	findNaoAssociadosVendas(column, order, page, limit, idempresa, ...params) {
		return this._http.get( encodeURI(`${this._env}/vendas/forma-pagamento/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idempresa=${idempresa}&param=${params}`), this._headers ).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

    findNaoAssociadosAgro(column, order, page, limit, idempresa, ...params) {
		return this._http.get( encodeURI(`${this._env}/agro/forma-pagamento/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idempresa=${idempresa}&param=${params}`), this._headers ).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}
}